/* ==========================================================================
   BELORA - WONDERSKIN MASTER / YORUM LISTESI

   VERI: assets/belora-reviews.generated.json  (tek kaynak)
     965 dogrulanmis yorum, 559'unda GERCEK satin alinan beden,
     571'inde boy + kilo. Eksik alan UYDURULMAZ; sadece basilmaz.

   Ozet bloklari sunucuda basildigi icin bu dosya CLS uretmez; liste
   ilk gorunume girdiginde (IntersectionObserver) cekilir.
   ========================================================================== */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ⚠️ BEDEN ETIKETI NORMALIZASYONU - GORUNTU KATMANI.
     Sahip Shopify beden secenek degerlerini harf-only yapti (XXS..XXL),
     ama `belora-reviews.generated.json` KAYNAK verisi (559 kayit) hala
     eski "34-XXS" formatinda - bu KAYIT DEGISTIRILMEZ (gercek satin
     alma verisi). Yalniz MUSTERI YUZUNDEKI metin normalize edilir.
     DAR, ACIK harita: taninmayan bir deger AYNEN birakilir (uydurma
     eslesme YOK), boylece ileride farkli bir format gelirse sessizce
     yanlis gosterilmez - oldugu gibi kalir. */
  var SIZE_LABEL_MAP = {
    '34-XXS': 'XXS', '36-XS': 'XS', '38-S': 'S', '40-M': 'M',
    '42-L': 'L', '44-XL': 'XL', '46-XXL': 'XXL'
  };
  function normalizeSizeLabel(raw) {
    if (!raw) return raw;
    return Object.prototype.hasOwnProperty.call(SIZE_LABEL_MAP, raw) ? SIZE_LABEL_MAP[raw] : raw;
  }

  function trDate(iso) {
    if (!iso) return '';
    var p = String(iso).split('-');
    if (p.length !== 3) return '';
    var months = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
    var m = parseInt(p[1], 10) - 1;
    if (m < 0 || m > 11) return '';
    return parseInt(p[2], 10) + ' ' + months[m] + ' ' + p[0];
  }

  var STAR = '<svg width="13" height="13" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="m10 1.6 2.5 5.4 5.9.7-4.4 4 1.2 5.8L10 14.6 4.8 17.5 6 11.7 1.6 7.7l5.9-.7L10 1.6Z"/></svg>';
  var CHECK = '<svg width="13" height="13" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="m4 10.4 4 4 8-9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function card(r) {
    var stars = '';
    for (var i = 0; i < (r.rating || 5); i++) stars += STAR;

    var meta = [];
    if (r.purchased_size) meta.push('Aldığı beden: <b>' + esc(normalizeSizeLabel(r.purchased_size)) + '</b>');
    if (r.height_cm && r.weight_kg) meta.push('Boy/kilo: <b>' + esc(r.height_cm) + ' cm / ' + esc(r.weight_kg) + ' kg</b>');

    return '' +
      '<li class="ws-rev__item">' +
        '<div class="ws-rev__item-top">' +
          '<span class="ws-rev__item-stars" aria-label="' + (r.rating || 5) + ' / 5">' + stars + '</span>' +
          '<span class="ws-rev__item-name">' + esc(r.name || '') + '</span>' +
          (r.verified ? '<span class="ws-rev__verified">' + CHECK + 'Doğrulanmış alışveriş</span>' : '') +
          '<span class="ws-rev__item-date">' + esc(trDate(r.date)) + '</span>' +
        '</div>' +
        (r.title ? '<p class="ws-rev__item-text"><b>' + esc(r.title) + '</b></p>' : '') +
        '<p class="ws-rev__item-text">' + esc(r.text || '') + '</p>' +
        (meta.length ? '<div class="ws-rev__item-meta"><span>' + meta.join('</span><span>') + '</span></div>' : '') +
      '</li>';
  }

  function init(root) {
    var boxes = (root || document).querySelectorAll('[data-ws-reviews]');
    Array.prototype.forEach.call(boxes, function (box) {
      if (box.__ws) return;
      box.__ws = true;

      var list = box.querySelector('[data-ws-list]');
      var more = box.querySelector('[data-ws-more]');
      var empty = box.querySelector('[data-ws-empty]');
      var sortSel = box.querySelector('[data-ws-sort]');
      var chips = Array.prototype.slice.call(box.querySelectorAll('[data-ws-size]'));
      var pageSize = parseInt(box.getAttribute('data-page-size'), 10) || 8;

      var all = [];
      var view = [];
      var shown = 0;
      var size = '';
      var sort = 'recent';
      var loaded = false;
      // ⚠️ Ilk sayfa SUNUCUDA basildi (snippets/ws-reviews-seed.liquid).
      //    Ayni 8 karti JS ile yeniden basmak DOM'u bosuna degistirir; asil
      //    onemlisi, listeyi once bosaltmak footer'i yukari/asagi oynatip
      //    CLS uretiyordu. Seed varsa ilk apply DOM'a DOKUNMAZ.
      var seeded = list ? list.children.length : 0;

      function apply() {
        view = all.filter(function (r) { return !size || normalizeSizeLabel(r.purchased_size) === size; });
        if (sort === 'long') view = view.slice().sort(function (a, b) { return (b.text || '').length - (a.text || '').length; });
        else view = view.slice().sort(function (a, b) { return String(b.date).localeCompare(String(a.date)); });
        if (seeded) {
          // Sunucudaki kartlar zaten view'in ilk sayfasi: oldugu gibi birakilir.
          shown = Math.min(seeded, view.length);
          seeded = 0;
          if (more) more.hidden = shown >= view.length;
          if (empty) empty.hidden = view.length !== 0;
          return;
        }
        shown = 0;
        list.innerHTML = '';
        render();
      }

      function render() {
        var next = view.slice(shown, shown + pageSize);
        list.insertAdjacentHTML('beforeend', next.map(card).join(''));
        shown += next.length;
        if (more) more.hidden = shown >= view.length;
        if (empty) {
          var none = view.length === 0;
          empty.hidden = !none;
          if (none) {
            empty.textContent = size
              ? size + ' bedeni için yazılı yorum bulunmuyor. Tüm yorumları görmek için "Tümü" seçebilirsin.'
              : 'Henüz yazılı yorum yok.';
          }
        }
      }

      function load() {
        if (loaded) return;
        loaded = true;
        fetch(box.getAttribute('data-json'), { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            if (!j || !j.products) return;
            var p = j.products[box.getAttribute('data-handle')];
            if (!p) return;

            all = (p.reviews || []).filter(function (r) { return r.text && r.text.trim(); });

            // Ozet sayilari VERIDEN dogrulanir - sabit metin veriyle celisemez.
            if (p.summary) {
              var t = box.querySelector('[data-ws-total]');
              if (t && p.summary.review_count) t.textContent = p.summary.review_count;
              var a = box.querySelector('[data-ws-avg]');
              // ⚠️ Sunucu '5,0' basiyor; ham sayi '5' olarak gelirse ekranda
              //    5,0 -> 5 diye titrer. Tek ondalik + TR virgul ile sabitlenir.
              if (a && p.summary.rating_average) a.textContent = Number(p.summary.rating_average).toFixed(1).replace('.', ',');
              var dist = p.summary.rating_distribution || {};
              Object.keys(dist).forEach(function (k) {
                var el = box.querySelector('[data-ws-dist-count="' + k + '"]');
                if (el) el.textContent = dist[k].count;
                var row = el && el.closest('li');
                var bar = row && row.querySelector('.ws-rev__dist-bar span');
                if (bar) bar.style.width = (dist[k].percent || 0) + '%';
              });
            }

            // Gercek satin alinan bedeni OLMAYAN filtre cipleri gosterilmez.
            var present = {};
            all.forEach(function (r) { if (r.purchased_size) present[normalizeSizeLabel(r.purchased_size)] = true; });
            chips.forEach(function (c) {
              var s = c.getAttribute('data-ws-size');
              if (s && !present[s]) c.hidden = true;
            });

            apply();
          })
          .catch(function () {
            if (empty) { empty.hidden = false; empty.textContent = 'Değerlendirmeler şu an yüklenemedi.'; }
          });
      }

      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          seeded = 0; // kullanici filtreledi: sunucu seed'i artik gecerli degil
          size = c.getAttribute('data-ws-size') || '';
          chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
          apply();
        });
      });
      if (sortSel) sortSel.addEventListener('change', function () { seeded = 0; sort = sortSel.value; apply(); });
      if (more) more.addEventListener('click', render);

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
        }, { rootMargin: '400px' });
        io.observe(box);
      } else {
        load();
      }
      // Sayfa ici bir baglanti dogrudan buraya atlarsa beklemeden yukle.
      window.addEventListener('hashchange', function () {
        if (location.hash && box.closest('section') && box.closest('section').id === location.hash.slice(1)) load();
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
